import { gql } from '@apollo/client';
import { CredentialTypeBasicFieldsFragment, GroupingBasicFieldsFragment } from '../../../api/gql/taxi-backend/v1/fragments';

export const GetCredentialAndGrouping = gql`
  query GetCredentialAndGrouping($credentialTypeIdInt: Int!, $groupingIdInt: Int!) {
    credentialType(id: $credentialTypeIdInt) {
      ...CredentialTypeBasicFieldsFragment
    }
    grouping(id: $groupingIdInt) {
       ...GroupingBasicFieldsFragment
          programs
          programsOfStudy {
            id
            centralParkUUID
            publicAlias
            credential_type_id
          }
          forms {
            id
            name
            program
            publishedStatus
            isExperimentalForm
            gdprSetting
            formMetadata {
              formAttributesConfig
            }
          }
    }
  }
  ${CredentialTypeBasicFieldsFragment}
  ${GroupingBasicFieldsFragment}
`;
